function getChatCtx (store, rootState) {
  if (store && store.$chat) return store.$chat
  if (rootState && rootState.chat) return rootState.chat
  return null
}

function safeBeep () {
  try {
    var AudioCtx = window.AudioContext || window.webkitAudioContext
    if (!AudioCtx) return
    var ctx = new AudioCtx()
    var o = ctx.createOscillator()
    var g = ctx.createGain()
    o.type = 'sine'
    o.frequency.value = 880
    g.gain.value = 0.04
    o.connect(g)
    g.connect(ctx.destination)
    o.start()
    setTimeout(function () {
      try { o.stop() } catch (e) {}
      try { ctx.close() } catch (e) {}
    }, 120)
  } catch (e) {}
}

function tryBrowserNotify (title, body) {
  try {
    if (!('Notification' in window)) return null

    if (Notification.permission === 'default') {
      Notification.requestPermission()
      return null
    }

    if (Notification.permission !== 'granted') return null

    var n = new Notification(title, { body: body })
    return n
  } catch (e) {
    return null
  }
}

export default {
  init: function init (ctx) {
    return Promise.resolve(true)
  },

  toggleChat: function toggleChat ({ commit, state, rootState }) {
    commit('TOGGLE_CHAT')

    const isOpen = !!(state.ui && state.ui.isOpen)

    if (isOpen && (!state.rooms || !state.rooms.length)) {
      return this.dispatch('chatPlugin/loadRooms')
    }
    return Promise.resolve(true)
  },

  closeChat: function closeChat ({ commit }) {
    commit('CLOSE_CHAT')
    return Promise.resolve(true)
  },

  loadRooms: function loadRooms ({ commit, state, rootState }) {
    var chat = getChatCtx(this, rootState)
    if (!chat || !chat.api || !chat.api.getRooms) {
      return Promise.reject(new Error('chat api not available'))
    }

    return chat.api.getRooms()
      .then(function (response) {
        var rooms = (response && response.data) ? response.data : response
        if (!Array.isArray(rooms)) rooms = []

        commit('SET_ROOMS', rooms)

        // JOIN EM TODAS AS SALAS (idempotente no SocketService agora)
        if (chat.socket && typeof chat.socket.joinRoom === 'function') {
          rooms.forEach(function (r) {
            if (r && r.id) chat.socket.joinRoom(r.id)
          })
        }

        return rooms
      })
  },

  selectRoom: function selectRoom ({ commit, state, rootState }, roomId) {
    var chat = getChatCtx(this, rootState)

    commit('SET_ACTIVE_ROOM', roomId)

    // reforço de join (idempotente no SocketService agora)
    if (chat && chat.socket) chat.socket.joinRoom(roomId)

    // carrega mensagens
    return this.dispatch('chatPlugin/loadMessages', { roomId: roomId })
  },

  loadMessages: function loadMessages ({ commit, rootState }, payload) {
    var chat = getChatCtx(this, rootState)
    if (!chat || !chat.api || !chat.api.getMessages) {
      return Promise.reject(new Error('chat api not available'))
    }

    var roomId = payload.roomId
    return chat.api.getMessages(roomId, { limit: 100 })
      .then(function (response) {
        var messages = (response && response.data) ? response.data : response
        if (!Array.isArray(messages)) messages = []
        commit('SET_MESSAGES', { roomId: roomId, messages: messages })
        return messages
      })
  },

  sendMessage: function sendMessage ({ commit, rootState }, payload) {
    var chat = getChatCtx(this, rootState)
    if (!chat || !chat.api || !chat.api.sendMessage) {
      return Promise.reject(new Error('chat api not available'))
    }

    var roomId = payload.roomId

    var content = payload.content
    var files = payload.files

    if (typeof payload === 'string') {
      content = payload
      files = []
    }

    return chat.api.sendMessage(roomId, content, files)
      .then(function (response) {
        var message = (response && response.data) ? response.data : response
        if (message) {
          commit('ADD_MESSAGE', { roomId: roomId, message: message })
          commit('UPDATE_LAST_MESSAGE', { roomId: roomId, message: message })
        }
        return message
      })
  },

  handleNewMessage: function handleNewMessage ({ commit, state, rootState }, message) {
    if (!message || !message.roomId) return

    // usuário logado (ajuste se sua store auth for diferente)
    var currentUserId =
      rootState && rootState.auth && rootState.auth.user
        ? rootState.auth.user.id
        : null

    // evita adicionar a mensagem duas vezes (uma pela resposta do sendMessage e outra pelo socket)
    var isOwn = currentUserId && String(message.senderId) === String(currentUserId)
    if (isOwn) {
      commit('ADD_MESSAGE', { roomId: message.roomId, message: message, silent: true })
      commit('UPDATE_LAST_MESSAGE', { roomId: message.roomId, message: message })
      return
    }

    commit('ADD_MESSAGE', { roomId: message.roomId, message: message })
    commit('UPDATE_LAST_MESSAGE', { roomId: message.roomId, message: message })

    var isChatOpen = !!(state.ui && state.ui.isOpen)
    var isActiveRoom = String(state.activeRoomId) === String(message.roomId)

    // notifica somente se não estiver vendo a sala ou chat fechado
    if (!isActiveRoom || !isChatOpen) {
      safeBeep()

      var room = (state.rooms || []).find(function (r) { return String(r.id) === String(message.roomId) })
      var roomName = room && room.name ? room.name : 'Nova mensagem'
      var senderName = message.sender && message.sender.nome ? message.sender.nome : 'Alguém'
      var preview = message.content ? String(message.content) : ''

      tryBrowserNotify(roomName, senderName + ': ' + preview)
    }
  },

  reconnectAndJoinRooms: function reconnectAndJoinRooms ({ rootState }, userId) {
    var chat = getChatCtx(this, rootState)
    if (!chat || !chat.socket) return Promise.resolve(false)

    chat.socket.connect(userId)

    return this.dispatch('chatPlugin/loadRooms')
  },

  requestNotificationPermission: function requestNotificationPermission () {
    try {
      if (!('Notification' in window)) return Promise.resolve(false)
      if (Notification.permission === 'granted') return Promise.resolve(true)
      if (Notification.permission === 'denied') return Promise.resolve(false)
      return Notification.requestPermission().then(function (p) { return p === 'granted' })
    } catch (e) {
      return Promise.resolve(false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/chat-plugin/store/actions.js